export const AttributeTypes = {
  text: 'text',
  selection : 'selection',
};



// WEBPACK FOOTER //
// ./src/models/respondentProfileTemplates/AttributeTypes.js